(() => {
  const update = (select) => {
    const value = select.options[select.selectedIndex]?.text || '';
    const match = value.match(/^\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:ft|feet)\s*$/i);
    let note = select.parentElement.querySelector('[data-ac-dimension-equivalent]');
    if (!match) { if (note) note.remove(); return; }
    if (!note) {
      note = document.createElement('p');
      note.className = 'ac-dimension-equivalent';
      note.dataset.acDimensionEquivalent = '';
      note.setAttribute('aria-live', 'polite');
      select.insertAdjacentElement('afterend', note);
    }
    note.textContent = `≈ ${Math.round(Number(match[1]) * 30.48)} × ${Math.round(Number(match[2]) * 30.48)} cm`;
  };
  const init = () => document.querySelectorAll('.single-option-selector').forEach(update);
  document.addEventListener('change', (event) => { if (event.target.matches('.single-option-selector')) update(event.target); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
